import { useTranslation } from "react-i18next";
import ResponsiveSheet from "@Components/ResponsiveSheet/ResponsiveSheet";
import BaggageGuidelinesContent from "./components/BaggageGuidelinesContent";

export default function BaggageGuidelines() {
  const { t } = useTranslation();

  return (
    <ResponsiveSheet
      label={t("Flights.details.ssr.baggageGuidelines")}
      renderTrigger={({ open }) => (
        <button
          onClick={open}
          className="text-font-active p-0! flex! items-center! justify-center! font-semibold! text-xs! md:text-base! cursor-pointer"
        >
          {t("Flights.details.ssr.baggageGuidelines")}
        </button>
      )}
      renderSheet={() => (
        <div className="px-3" onClick={(e) => e.stopPropagation()}>
          <BaggageGuidelinesContent />
        </div>
      )}
    />
  );
}
